import { useState, useEffect } from "react";
import { findCountryByValue } from '../../../lib/countries/countries.utils'

import type { UseFormRegisterReturn } from "react-hook-form";
import type { Language } from "../../../types/menuTypes";

type MainLanguageSelectorProps = {
  id: string;
  onChange: (value: string) => void;
  languages?: Language[];
  register?: UseFormRegisterReturn;
  mainLanguage?: string;
}

const MainLanguageSelector = ({
  id,
  onChange,
  languages = [],
  register,
  mainLanguage = ''
}: MainLanguageSelectorProps) => {
  const [defaultLanguage, setDefaultLanguage ] = useState<string>(mainLanguage);

  const makeMainLanguage = (language: Language) => {
    setDefaultLanguage(language.language)
  }

  useEffect(() => {
    onChange(defaultLanguage);
  }, [defaultLanguage, onChange]);

  return (
    <div  className="mt-2 relative">
      <input
        id={id}
        {...register}
        value={defaultLanguage}
        hidden
      />              
      <ul className='mt-1 text-gray-900 dark:text-white/90'>
        {languages.map((l: Language) => {
          const country = findCountryByValue(l.language)
          return (
            <li key={l.position} 
                className={`${
                  defaultLanguage === l.language? "bg-success-500 text-white dark:text-white" : "bg-gray-400 dark:bg-white/5 text-white dark:text-white/80"
                } mr-2 inline-flex items-center px-2.5 py-0.5 justify-center gap-1 rounded-full font-medium text-sm`}  
                onClick={() => makeMainLanguage(l)}
            >    
              <span className="mr-2">
                {country?.flag}
              </span>
              {country?.title}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
export default MainLanguageSelector
